import Skeleton from 'react-loading-skeleton';
const HomeSkeleton = () => {
  return (
    <div className="p-4 flex flex-col items-center">
      <div className="w-full">
        <Skeleton
          style={{
            width: '100%',
            height: '180px',
            borderRadius: '16px',
            marginBottom: '16px',
          }}
        />
      </div>
      <div
        className={
          'grid grid-flow-row grid-cols-2 grid-rows-3 gap-4 w-full mb-4'
        }
      >
        <Skeleton style={{ height: '56px', borderRadius: '12px' }} />
        <Skeleton style={{ height: '56px', borderRadius: '12px' }} />
        <Skeleton style={{ height: '56px', borderRadius: '12px' }} />
        <Skeleton style={{ height: '56px', borderRadius: '12px' }} />
        <Skeleton style={{ height: '56px', borderRadius: '12px' }} />
        <Skeleton style={{ height: '56px', borderRadius: '12px' }} />
      </div>
      <div className={'w-full'}>
        <Skeleton count={8} />
      </div>
    </div>
  );
};

export default HomeSkeleton;
